import { Box } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import FormModalContainer from '../../../components/Modals/FormModalContainer'
import SortByList from '../../../components/PageHelpers/Sort'
import { selectUsersBatchActionsStatus } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusSlice'
import { getFilterUsersBatchActionsStatusList, getUsersBatchActionsStatusList } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusThunk'
import UseTranslation from '../../../hooks/UseTranslation'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'
import OfoqMultiAutoComplete from '../../../components/Forms/OfoqMultiAutoComplete'
import ActiveFiltersWithKey from '../../../components/PageHelpers/ActiveFiltersWithKey'
import CookiesStorageService from '../../../services/CookiesStorageService'

const Mobile = ({
  openModal,
  setOpenModal,
  status,
  setStatus,
  types,
  setTypes,
}) => {
  const usersBatchActionsStatusStore = useSelector(selectUsersBatchActionsStatus)
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const handleClose = () => {
    setOpenModal(false)
  }
  const clearAllFilters = () => {
    dispatch(getFilterUsersBatchActionsStatusList({ queries: 'clear' }))
  }
  const isFilteredArraysNotEmpty = Object.values(usersBatchActionsStatusStore?.activeFilters).some(
    (singleFilter) => singleFilter?.length,
  )
  const isSamlUser = CookiesStorageService.getIsSamlUser()
  return (
    <FormModalContainer
      modalTitle={`${t?.['Filter By']}`}
      modalState={openModal}
      handleClose={handleClose}
      cancelText={t?.close}
    >
      <Box sx={styles.filterBox} >
         {isFilteredArraysNotEmpty && (
        <ActiveFiltersWithKey
          title={t?.['Applied Filters']}
          store={usersBatchActionsStatusStore}
          actionToDispatch={getFilterUsersBatchActionsStatusList}
          customStyles={styles.activeFilter}
        />
         )}
         {isFilteredArraysNotEmpty && (
        <ActiveFiltersWithKey
          title={t?.['Applied Filters']}
          store={usersBatchActionsStatusStore}
          actionToDispatch={getFilterUsersBatchActionsStatusList}
          customStyles={styles.activeFilter}
        />
         )}
        <SortByList
          actionToDispatch={getUsersBatchActionsStatusList}
          store={usersBatchActionsStatusStore}
          sendQueryAsObject
        />
        {!isSamlUser && (
         <OfoqMultiAutoComplete
          name={t?.Type}
          store={usersBatchActionsStatusStore?.filterList?.types}
          defaultOption={types}
          refState={setTypes}
          customStyle={styles.firstFilter}
        />
        )}
        <OfoqMultiAutoComplete
          name={t?.Status}
          store={usersBatchActionsStatusStore?.filterList?.status}
          defaultOption={status}
          refState={setStatus}
          customStyle={styles.firstFilter}
          multiple
        />
      </Box>
 <OfoqThemeBtn
        name={`${t?.['Clear Filters']}`}
         onClick={clearAllFilters}
        customStyle={styles.clearFilters}
      />
    </FormModalContainer>
  )
}

const styles = {
  filterBox: {
    display: 'flex',
    gap: { xs: '5px', md: '23px' },
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
    my: '20px',
  },
  firstFilter: {
    marginInline: { xs: '0px', md: '10px' },
    marginBottom: '0px',
  },
  activeFilter: {
    flexWrap: 'wrap',
  },
  clearFilters: {
    width: { xs: '100%', sm: '0px' },
    maxWidth: { xs: '100%', md: '150px' },
    minWidth: { xs: '80px', sm: '0px' },
    marginTop: { xs: '30px', sm: 'unset' },
  },
}

export default Mobile
